import { FC, useEffect, useState } from "react";
import "@/components/navigation/navigationBar.css";
import ManagerRoutes from "@/components/navigation/managerRoutes";
import GeneralRoutes from "@/components/navigation/generalRoutes";
import AdminRoutes from "@/components/navigation/adminRoutes";
import CustomerRoutes from "@/components/navigation/customerRoutes";

// RoutesIndex
// generalRoutes 0-10
// managerRoutes 10-20
// adminRoutes 20-40
// customerRoutes 50-60

//trackesServiceRoutesPREFIX 50

interface Props {
  drawerOpen: boolean;
  subdomain: string;
  closeDrawer: () => void;
  location: any;
}

const NavigationRoutes: FC<Props> = ({
  drawerOpen,
  subdomain,
  closeDrawer,
  location,
}) => {
  const [subrouteOpenAtLocation, setSubrouteOpenAtLocation] = useState<any>({});
  const index =
    location.pathname === "/"
      ? 0
      : location.pathname === "/todo" || location.pathname === "/todo/"
      ? 1
      : location.pathname === "/document" || location.pathname === "/document/"
      ? 2
      : location.pathname === "/accidentBook" ||
        location.pathname === "/accidentBook/"
      ? subdomain === "portal"
        ? 52
        : 15
      : location.pathname === "/mitarbeiter" ||
        location.pathname === "/mitarbeiter/"
      ? 10
      : (location.pathname === "/appointmentrequestopen" ||
          location.pathname === "/appointmentrequestopen/") &&
        subdomain === "manage"
      ? 11
      : (location.pathname === "/buildings" ||
          location.pathname === "/buildings/") &&
        subdomain === "manage"
      ? 12
      : (location.pathname === "/appointmentArchive" ||
          location.pathname === "/appointmentArchive/") &&
        subdomain === "manage"
      ? 13
      : location.pathname === "/appointmentDashboard" ||
        location.pathname === "/appointmentDashboard/"
      ? 20
      : location.pathname === "/appointmentrequest" ||
        location.pathname === "/appointmentrequest/"
      ? 21
      : location.pathname === "/settings/mainCategoryList" ||
        location.pathname === "/settings/mainCategoryList/"
      ? 22
      : location.pathname === "/settings/examinationList" ||
        location.pathname === "/settings/examinationList/"
      ? 23
      : location.pathname === "/settings/probeList" ||
        location.pathname === "/settings/probeList/"
      ? 24
      : location.pathname === "/settings/measurementDefinitionList" ||
        location.pathname === "/settings/measurementDefinitionList/"
      ? 25
      : location.pathname === "/settings/appointmentList" ||
        location.pathname === "/settings/appointmentList/"
      ? 26
      : location.pathname === "/settings/templateEditor" ||
        location.pathname === "/settings/templateEditor/"
      ? 27
      : location.pathname === "/settings/documentEditor" ||
        location.pathname === "/settings/documentEditor/"
      ? 28
      : location.pathname === "/userAdministration" ||
        location.pathname === "/userAdministration/"
      ? 29
      : location.pathname === "/admin/companyList" ||
        location.pathname === "/admin/companyList/"
      ? 30
      : location.pathname === "/admin/todoList" ||
        location.pathname === "/admin/todoList/"
      ? 31
      : location.pathname === "/settings/ruleList" ||
        location.pathname === "/settings/ruleList/"
      ? 33
      : location.pathname === "/settings/mailTemplateList" ||
        location.pathname === "/settings/mailTemplateList/"
      ? 34
      : location.pathname === "/settings/permissionList" ||
        location.pathname === "/settings/permissionList/"
      ? 37
      : location.pathname === "/settings/permissionGroupList" ||
        location.pathname === "/settings/permissionGroupList/"
      ? 38
      : location.pathname === "/admin/teams" ||
        location.pathname === "/admin/teams/"
      ? 39
      : location.pathname === "/settings/auditlog" ||
        location.pathname === "/settings/auditlog/"
      ? 40
      : location.pathname === "/settings/finding" ||
        location.pathname === "/settings/finding/"
      ? 41
      : location.pathname === "/admin/subjectOverview" ||
        location.pathname === "/admin/subjectOverview/"
      ? 42
      : location.pathname === "/settings/missingTranslations" ||
        location.pathname === "/settings/missingTranslations/"
      ? 45
      : location.pathname === "/settings/accessfailurelog" ||
        location.pathname === "/settings/accessfailurelog/"
      ? 46
      : location.pathname === "/settings/globalSettings" ||
        location.pathname === "/settings/globalSettings/"
      ? 47
      : location.pathname === "/trackedService/recorded" ||
        location.pathname === "/trackedService/recorded/"
      ? 5000
      : location.pathname === "/trackedService/types" ||
        location.pathname === "/trackedService/types/"
      ? 5001
      : location.pathname === "/trackedService/trackedServiceTemplates" ||
        location.pathname === "/trackedService/trackedServiceTemplates/"
      ? 5002
      : location.pathname === "/trackedService/examinationTemplates" ||
        location.pathname === "/trackedService/examinationTemplates/"
      ? 5003
      : location.pathname === "/kaerdemy" ||
        location.pathname === "/kaerdemy/" ||
        location.pathname === "/kaerdemy/administrator/overview" ||
        location.pathname === "/kaerdemy/administrator/overview/" ||
        location.pathname === "/kaerdemy/manager/overview" ||
        location.pathname === "/kaerdemy/manager/overview/" ||
        (subdomain === "portal" &&
          (location.pathname === "/kaerdemy/learner/courses" ||
            location.pathname === "/kaerdemy/learner/courses/" ||
            location.pathname.startsWith("/kaerdemy/learner/courses/") ||
            location.pathname.startsWith("/kaerdemy/learner/enrolments/")))
      ? 6000
      : location.pathname === "/kaerdemy/administrator/enrolments" ||
        location.pathname === "/kaerdemy/administrator/enrolments/" ||
        location.pathname === "/kaerdemy/manager/enrolments" ||
        location.pathname === "/kaerdemy/manager/enrolments/"
      ? 6002
      : location.pathname === "/kaerdemy/administrator/billing" ||
        location.pathname === "/kaerdemy/administrator/billing/"
      ? 6003
      : location.pathname === "/kaerdemy/administrator/enrolment-assignments" ||
        location.pathname ===
          "/kaerdemy/administrator/enrolment-assignments/" ||
        location.pathname === "/kaerdemy/administrator/enrolmentAssignments" ||
        location.pathname === "/kaerdemy/administrator/enrolmentAssignments/" ||
        location.pathname === "/kaerdemy/manager/enrolmentAssignments" ||
        location.pathname === "/kaerdemy/manager/enrolmentAssignments/"
      ? 6004
      : location.pathname === "/kaerdemy/courses" ||
        location.pathname === "/kaerdemy/courses/" ||
        location.pathname === "/kaerdemy/learner/courses" ||
        location.pathname === "/kaerdemy/learner/courses/" ||
        location.pathname.startsWith("/kaerdemy/learner/courses/") ||
        location.pathname.startsWith("/kaerdemy/learner/enrolments/") ||
        location.pathname === "/kaerdemy/administrator/courses" ||
        location.pathname === "/kaerdemy/administrator/courses/" ||
        location.pathname.startsWith("/kaerdemy/administrator/courses/") ||
        location.pathname === "/kaerdemy/manager/courses" ||
        location.pathname === "/kaerdemy/manager/courses/" ||
        location.pathname.startsWith("/kaerdemy/manager/courses/")
      ? 6001
      : (location.pathname === "/appointmentrequestopen" ||
          location.pathname === "/appointmentrequestopen/") &&
        subdomain === "portal"
      ? 50
      : (location.pathname === "/appointmentArchive" ||
          location.pathname === "/appointmentArchive/") &&
        subdomain === "portal"
      ? 51
      : undefined;

  const [selectedIndex, setSelectedIndex] = useState<any>(index);

  useEffect(() => {
    if (location.pathname.includes("admin")) {
      setSubrouteOpenAtLocation("admin");
    }
    if (location.pathname.includes("settings")) {
      setSubrouteOpenAtLocation("settings");
    }
    if (location.pathname.includes("trackedservice")) {
      setSubrouteOpenAtLocation("trackedservice");
    }
    if (location.pathname.includes("kaerdemy")) {
      setSubrouteOpenAtLocation("klearning");
    }
  }, [location]);

  const handleListItemClick = (event: any, index: any) => {
    setSelectedIndex(index);
    closeDrawer();
  };
  const handleListSoubrouteItemClick = (event: any, index: any) => {
    setSelectedIndex(index);
    closeDrawer();
  };

  return (
    <>
      <GeneralRoutes
        drawerOpen={drawerOpen}
        selectedIndex={selectedIndex}
        handleListItemClick={handleListItemClick}
      />
      <ManagerRoutes
        drawerOpen={drawerOpen}
        selectedIndex={selectedIndex}
        handleListItemClick={handleListItemClick}
        handleListSoubrouteItemClick={handleListSoubrouteItemClick}
        subdomain={subdomain}
        subRouteToOpen={subrouteOpenAtLocation}
      />
      <CustomerRoutes
        drawerOpen={drawerOpen}
        selectedIndex={selectedIndex}
        handleListItemClick={handleListItemClick}
        subdomain={subdomain}
      />
      <AdminRoutes
        drawerOpen={drawerOpen}
        selectedIndex={selectedIndex}
        handleListItemClick={handleListItemClick}
        handleListSoubrouteItemClick={handleListSoubrouteItemClick}
        subdomain={subdomain}
        subRouteToOpen={subrouteOpenAtLocation}
      />
    </>
  );
};

export default NavigationRoutes;
